import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LoadScript } from '@react-google-maps/api';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId="608653293565-tjprro9l9v9io04l3or64jpumst0lr9a.apps.googleusercontent.com">
        <LoadScript
          googleMapsApiKey="AIzaSyB6W6WJjs-e1yPpfSBa9E5aoKxAAAClD-s"
          libraries={['places']}
        >
          <App />
        </LoadScript>
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
} else {
  throw new Error("No se encontró el elemento con id 'root'");
}

reportWebVitals();
